
import mixin from './mixin';

export default {
  mixins: [mixin],
  props: {
    color: {
      type: String,
      default: '#000000'
    },
    rgba: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 152
    }
  },
  data: function data() {
    return {
      slideAlphaStyle: {},
      alphaSize: 5
    };
  },

  watch: {
    color: function color() {
      this.renderColor();
    },
    'rgba.a': function rgbaA() {
      this.renderSlide();
    }
  },
  mounted: function mounted() {
    this.renderColor();
    this.renderSlide();
  },

  methods: {
    renderColor: function renderColor() {
      var canvas = this.$refs.canvasAlpha;
      var width = this.width;
      var height = this.height;
      var size = this.alphaSize;
      var canvasSquare = this.createAlphaSquare(size);

      var ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;

      ctx.fillStyle = ctx.createPattern(canvasSquare, 'repeat');
      ctx.fillRect(0, 0, width, height);

      this.createLinearGradient('p', ctx, width, height, 'rgba(255,255,255,0)', this.color);
    },
    renderSlide: function renderSlide() {
      this.slideAlphaStyle = {
        top: this.rgba.a * this.height - 2 + 'px'
      };
    },
    selectAlpha: function selectAlpha(e) {
      var _this = this;

      var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
          hueTop = _$el$getBoundingClien.top;

      var mousemove = function mousemove(e) {
        var y = e.clientY - hueTop;

        if (y < 0) {
          y = 0;
        }
        if (y > _this.height) {
          y = _this.height;
        }

        var a = parseFloat((y / _this.height).toFixed(2));
        _this.$emit('selectAlpha', a);
      };

      mousemove(e);

      var mouseup = function mouseup() {
        document.removeEventListener('mousemove', mousemove);
        document.removeEventListener('mouseup', mouseup);
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
    }
  }
};